export default __webpack_public_path__ + "static/media/gold-necklace.28391f0d.webp";